import type { WorldcupOverviewTeam } from './types'

const fixtureTeamLogoAliasesById = new Map<number, string>([
  [770, '/worldcup/teams/cze.svg'],
  [1113, '/worldcup/teams/bih.svg'],
  [2380, '/worldcup/teams/par.svg'],
  [2386, '/worldcup/teams/hai.svg'],
  [5530, '/worldcup/teams/cuw.svg'],
  [1533, '/worldcup/teams/cpv.svg'],
  [4673, '/worldcup/teams/nzl.svg'],
  [1567, '/worldcup/teams/irq.svg'],
  [1548, '/worldcup/teams/jor.svg'],
  [1508, '/worldcup/teams/cod.svg'],
  [1568, '/worldcup/teams/uzb.svg'],
])

const fixtureTeamLogoAliasesByName = new Map<string, string>([
  ['algeria', '/worldcup/teams/alg.svg'],
  ['argentina', '/worldcup/teams/arg.svg'],
  ['australia', '/worldcup/teams/aus.svg'],
  ['austria', '/worldcup/teams/aut.svg'],
  ['belgium', '/worldcup/teams/bel.svg'],
  ['bosnia & herzegovina', '/worldcup/teams/bih.svg'],
  ['bosnia and herzegovina', '/worldcup/teams/bih.svg'],
  ['bosnia-herzegovina', '/worldcup/teams/bih.svg'],
  ['bosnia herzegovina', '/worldcup/teams/bih.svg'],
  ['brazil', '/worldcup/teams/bra.svg'],
  ['cameroon', '/worldcup/teams/cmr.svg'],
  ['canada', '/worldcup/teams/can.svg'],
  ['cabo verde', '/worldcup/teams/cpv.svg'],
  ['cape verde', '/worldcup/teams/cpv.svg'],
  ['cape verde islands', '/worldcup/teams/cpv.svg'],
  ['chile', '/worldcup/teams/chi.svg'],
  ['colombia', '/worldcup/teams/col.svg'],
  ['congo dr', '/worldcup/teams/cod.svg'],
  ['costa rica', '/worldcup/teams/crc.svg'],
  ['croatia', '/worldcup/teams/cro.svg'],
  ['cote d\'ivoire', '/worldcup/teams/civ.svg'],
  ['cote divoire', '/worldcup/teams/civ.svg'],
  ['curaçao', '/worldcup/teams/cuw.svg'],
  ['curacao', '/worldcup/teams/cuw.svg'],
  ['czech republic', '/worldcup/teams/cze.svg'],
  ['czechia', '/worldcup/teams/cze.svg'],
  ['denmark', '/worldcup/teams/den.svg'],
  ['dr congo', '/worldcup/teams/cod.svg'],
  ['ecuador', '/worldcup/teams/ecu.svg'],
  ['egypt', '/worldcup/teams/egy.svg'],
  ['england', '/worldcup/teams/eng.svg'],
  ['france', '/worldcup/teams/fra.svg'],
  ['germany', '/worldcup/teams/ger.svg'],
  ['ghana', '/worldcup/teams/gha.svg'],
  ['haiti', '/worldcup/teams/hai.svg'],
  ['iran', '/worldcup/teams/irn.svg'],
  ['ir iran', '/worldcup/teams/irn.svg'],
  ['iraq', '/worldcup/teams/irq.svg'],
  ['italy', '/worldcup/teams/ita.svg'],
  ['ivory coast', '/worldcup/teams/civ.svg'],
  ['japan', '/worldcup/teams/jpn.svg'],
  ['jordan', '/worldcup/teams/jor.svg'],
  ['mali', '/worldcup/teams/mli.svg'],
  ['mexico', '/worldcup/teams/mex.svg'],
  ['morocco', '/worldcup/teams/mar.svg'],
  ['netherlands', '/worldcup/teams/ned.svg'],
  ['new zealand', '/worldcup/teams/nzl.svg'],
  ['nigeria', '/worldcup/teams/nga.svg'],
  ['norway', '/worldcup/teams/nor.svg'],
  ['panama', '/worldcup/teams/pan.svg'],
  ['paraguay', '/worldcup/teams/par.svg'],
  ['peru', '/worldcup/teams/per.svg'],
  ['poland', '/worldcup/teams/pol.svg'],
  ['portugal', '/worldcup/teams/por.svg'],
  ['qatar', '/worldcup/teams/qat.svg'],
  ['saudi arabia', '/worldcup/teams/ksa.svg'],
  ['scotland', '/worldcup/teams/sco.svg'],
  ['senegal', '/worldcup/teams/sen.svg'],
  ['serbia', '/worldcup/teams/srb.svg'],
  ['south africa', '/worldcup/teams/rsa.svg'],
  ['south korea', '/worldcup/teams/kor.svg'],
  ['spain', '/worldcup/teams/esp.svg'],
  ['sweden', '/worldcup/teams/swe.svg'],
  ['switzerland', '/worldcup/teams/sui.svg'],
  ['tunisia', '/worldcup/teams/tun.svg'],
  ['turkey', '/worldcup/teams/tur.svg'],
  ['turkiye', '/worldcup/teams/tur.svg'],
  ['ukraine', '/worldcup/teams/ukr.svg'],
  ['uruguay', '/worldcup/teams/uru.svg'],
  ['usa', '/worldcup/teams/usa.svg'],
  ['uzbekistan', '/worldcup/teams/uzb.svg'],
])

function normalizeTeamLogoKey(value: string): string {
  return value
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036F]/g, '')
    .replace(/[’`]/g, '\'')
    .replace(/\s+/g, ' ')
}

export function resolveWorldcupTeamLogo({
  teams,
  teamId,
  teamName,
}: {
  teams?: readonly Pick<WorldcupOverviewTeam, 'teamId' | 'name' | 'researchTeamParam' | 'logoUrl'>[] | null
  teamId?: number | null
  teamName: string
}) {
  const normalizedName = normalizeTeamLogoKey(teamName)
  const aliasedLogoUrl = (
    teamId == null
      ? undefined
      : fixtureTeamLogoAliasesById.get(teamId)
  ) ?? fixtureTeamLogoAliasesByName.get(normalizedName)

  return (
    teams?.find(team => team.teamId === teamId && normalizeTeamLogoKey(team.name) === normalizedName)?.logoUrl
    ?? teams?.find(team => normalizeTeamLogoKey(team.name) === normalizedName)?.logoUrl
    ?? teams?.find(team => normalizeTeamLogoKey(team.researchTeamParam) === normalizedName)?.logoUrl
    ?? teams?.find(team => team.teamId === teamId)?.logoUrl
    ?? aliasedLogoUrl
    ?? null
  )
}
